module.exports = __webpack_public_path__ + "img/warn_05.0c0fab0f.png";